import { Box, IconButton } from "@mui/material";
import { Icon } from "@iconify/react";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import moment from "moment";
function getNestedColumnValues(data, key) {
  if (!data || !Array.isArray(data.plantDetails)) return [];
  return data.plantDetails.map((plant, index) => (
    <div
      key={`${key}-${index}`}
      style={{ width: "max-content", marginBottom: "0.5rem" }}
    >
      {plant[key] || "N/A"}
    </div>
  ));
}
const getNoOfRevisions = (data, fieldKey) => {
  const maxRevisions = data?.reduce(
    (max, item) => Math.max(max, item.revision.length),
    0
  );
  const columns = [];
  for (let i = 1; i <= maxRevisions; i++) {
    let suffix = "th";
    if (i === 1) {
      suffix = "st";
    } else if (i === 2) {
      suffix = "nd";
    } else if (i === 3) {
      suffix = "rd";
    }
    columns.push({
      label: `${i}${suffix}`,
      id: `${fieldKey}`,
      render: (data) => {
        const revisionField = data?.revision?.[i - 1]?.[fieldKey] || "-";
        return <span>{revisionField}</span>;
      },
    });
  }
  if (columns.length) {
    return columns;
  } else {
    return ["-"];
  }
};

export const pendingServiceInfoHeaderConfig = [
  {
    label: "OEM",
    id: "oem",
    render: (data) => <span>{data?.oem?.name}</span>,
  },
  {
    label: "Release Date",
    id: "releaseDate",
    render: (data) => (
      <span>
        {data.releaseDate && moment(data.releaseDate).format("DD/MM/YYYY")}
      </span>
    ),
  },

  {
    label: "Engine Model",
    id: "engineModel",
    render: (data) => (
      <Box sx={{ maxWidth: "400px", wordBreak: "break-all" }}>
        {data?.engineModel?.join(", ")}
      </Box>
    ),
  },
  {
    label: "Defect",
    id: "defectCode",
    render: (data) => {
      return `${data?.defectCode?.code}-${data?.defectCode?.description}`;
    },
  },
  {
    label: "List Numbers",
    id: "listNumbers",
    render: (data) => (
      <Box sx={{ maxWidth: "400px", wordBreak: "break-all" }}>
        {data?.listNumbers?.join(", ")}
      </Box>
    ),
  },
  {
    label: "Plant",
    id: "plantDetails",
    columns: [
      {
        label: "Plant Name",
        id: "plantName",
        render: (data) => <>{getNestedColumnValues(data, "plantName")}</>,
      },
      {
        label: "Cut in Number",
        id: "cutInNumber",
        render: (data) => <>{getNestedColumnValues(data, "cutInNumber")}</>,
      },
      {
        label: "Cut in Date",
        id: "cutInDate",
        render: (data) => (
          <>
            {data.plantDetails?.map((plant, index) => (
              <div
                key={`cutInDate-${index}`}
                style={{ width: "max-content", marginBottom: "0.5rem" }}
              >
                {plant.cutInDate
                  ? moment(plant.cutInDate).format("DD/MM/YYYY")
                  : "N/A"}
              </div>
            ))}
          </>
        ),
      },
    ],
  },
  {
    label: "Subject",
    id: "subject",
  },
  {
    label: "Action",
    id: "action",
    render: (data, onClick) => (
      <Box sx={{ display: "flex" }}>
        <IconButton onClick={() => onClick("VIEW", data)}>
          <Icon
            icon="carbon:task-view"
            width="2rem"
            height="2rem"
            style={{ color: "#093986" }}
          />
        </IconButton>
      </Box>
    ),
  },
];
export const pendingServiceInfoFormConfig = (isBulletin = false) => [
  {
    name: isBulletin ? "sbNumber" : "siNumber",
    type: "text",
    label: isBulletin ? "SB No." : "SI No.",
    placeholder: isBulletin ? "Enter SB No." : "Enter SI No.",
  },
  {
    name: "oem",
    type: "text",
    label: "OEM Name",
    placeholder: "Select Oem",
  },
  {
    name: "defectCode",
    type: "text",
    label: "Defect",
    placeholder: "Select Defect",
  },
  {
    name: "releaseDate",
    type: "datePicker",
    label: "Released On",
    placeholder: "Release Date",
  },
  {
    name: "engineModel",
    type: "text",
    label: "Engine Models",
    placeholder: "Engine model",
  },
  {
    name: "listNumbers",
    type: "text",
    label: "List Numbers",
    placeholder: "List Number",
  },
  {
    name: "subject",
    type: "text",
    label: "Subject",
    placeholder: "Subject",
  },
];
export const pendingWorkshopManualFormConfig = () => [
  {
    name: "engineModel",
    type: "text",
    label: "Engine Model",
    placeholder: "Engine Model",
  },
  {
    name: "oem",
    type: "text",
    label: "OEM Organisation",
  },
  {
    name: "versionNumber",
    type: "text",
    label: "WSM Version",
    placeholder: " Version",
  },
  {
    name: "listNumber",
    type: "text",
    label: "List Number",
    placeholder: " List Number",
  },
  {
    name: "releasedOn",
    type: "datePicker",
    label: "Released On",
    placeholder: "Release Date",
  },
  {
    label: "Remarks",
    name: "remarks",
    placeholder: "Remarks for version change",
    type: "text",
  },
];
export const PendingServiceBulletinsFormConfig = () => [
  {
    name: "sbNumber",
    type: "text",
    label: "SI No.",
    placeholder: "Enter SI No.",
  },
  {
    name: "oem",
    type: "text",
    label: "OEM Name",
    placeholder: "Select Oem",
  },

  {
    name: "releaseDate",
    type: "datePicker",
    label: "Released On",
    placeholder: "Release Date",
  },
  {
    name: "engineModel",
    type: "text",
    label: "Engine Models",
    placeholder: "Engine model",
  },
  {
    name: "listNumbers",
    type: "text",
    label: "List Numbers",
    placeholder: "List Number",
  },
  {
    name: "subject",
    type: "text",
    label: "Subject",
    placeholder: "Subject",
  },
];
export const WorkshopHeaderConfig = (data) => {
  const result = [
    {
      label: "Engine Model",
      id: "engineModel",
    },
    {
      label: "List Number",
      id: "listNumber",
    },
    {
      label: "Version",
      id: "versionNumber",
    },
    {
      label: "released On",
      id: "releasedOn",
    },
    {
      label: "Remarks",
      id: "remarks",
    },
    // {
    //   label: "Revision",
    //   id: "revision",
    //   columns: getNoOfRevisions(data, "versionNumber"),
    // },
    // {
    //   label: "Remarks for revision",
    //   id: "revisionRemarks",
    //   columns: getNoOfRevisions(data, "remarks"),
    // },
    {
      label: "Action",
      id: "action",
      render: (data, onClick) => (
        <Box sx={{ display: "flex" }}>
          <IconButton onClick={() => onClick("VIEW", data)}>
            <Icon
              icon="carbon:task-view"
              width="2rem"
              height="2rem"
              style={{ color: "#093986" }}
            />
          </IconButton>
        </Box>
      ),
    },
  ];

  return result;
};
